// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__WGuNH","indigo":"Badge_indigo__BbKQW","sky":"Badge_sky__tqUCT","amber":"Badge_amber__6qo9m","emerald":"Badge_emerald__v8ttm","rose":"Badge_rose__2hVqC"};